__turbopack_context__.v({
  "list": "DashLeadList-module__b2tyFa__list",
});
